export default __webpack_public_path__ + "static/media/avtopark.e4d6f74f.jpg";